import { useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { HOSTING_CHANGED_EVENT } from '../utils/hostingStorage';

// Listing-страницы вызывают свой fetch при монтировании, но не реагируют на смену
// hosting_id из HostingSwitcher без перезагрузки страницы. Хук слушает параметр URL
// и кастомное событие 'hosting-changed' (диспатчит hostingStorage при set/clear) --
// нужно когда крестик HostingSwitcher чистит localStorage, а URL ?hosting_id и так
// был пустым (т.е. location.search не меняется и одного listener'а на URL не хватает).
// refetch держим через ref, иначе нестабильная ссылка (useCallback с внутренними deps)
// вызовет лишние запросы.
const useRefetchOnHostingChange = (refetch) => {
  const location = useLocation();
  const hostingId = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('hosting_id') || '';
  }, [location.search]);

  const refetchRef = useRef(refetch);
  useEffect(() => {
    refetchRef.current = refetch;
  }, [refetch]);

  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    if (typeof refetchRef.current === 'function') {
      refetchRef.current();
    }
  }, [hostingId]);

  useEffect(() => {
    const handler = () => {
      if (typeof refetchRef.current === 'function') {
        refetchRef.current();
      }
    };
    window.addEventListener(HOSTING_CHANGED_EVENT, handler);
    return () => window.removeEventListener(HOSTING_CHANGED_EVENT, handler);
  }, []);
};

export default useRefetchOnHostingChange;
